module.exports = __webpack_public_path__ + "static/media/nordisk.7a526a4a.webp";